/**
 * SenderAvatar (KAN-618)
 *
 * Small round avatar of OUR Telegram account: the picture from `avatarUrl`,
 * otherwise initials of the name. Loading rules: see useAvatarSrc; picture and
 * initials: RoundAvatar.
 */
import { RoundAvatar, type RoundAvatarSize } from '@/components/common/RoundAvatar'
import { useAvatarSrc } from '@/hooks/useAvatarSrc'

interface SenderAvatarProps {
  avatarUrl?: string | null
  /** Name the initials are taken from when there is no picture. */
  name?: string
  /** Diameter in px. */
  size?: RoundAvatarSize
  className?: string
}

export function SenderAvatar({ avatarUrl, name = '', size = 20, className }: SenderAvatarProps) {
  const src = useAvatarSrc(avatarUrl ?? '')
  return <RoundAvatar src={src} name={name} size={size} className={className} testId="sender-avatar" />
}
